import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import type { PortfolioListReportingSummaryResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { PortfolioItemIcon } from "web_myplann/Portfolio/Components/PortfolioItemIcon";
import { CurrencyAmount } from "web_myplann/Portfolio/Components/Redesign/ListItem/CurrencyAmount";
import { InvestmentPropertyBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/InvestmentPropertyBadge";
import { PortfolioRow } from "web_myplann/Portfolio/Components/Redesign/ListItem/PortfolioRow";
import { PortfolioRowTrailing } from "web_myplann/Portfolio/Components/Redesign/ListItem/PortfolioRowTrailing";
import { PortfolioTitle } from "web_myplann/Portfolio/Components/Redesign/ListItem/PortfolioTitle";
import { PropertyTitle } from "web_myplann/Portfolio/Components/Redesign/ListItem/PropertyTitle";
import {
	propertySubtitle,
	propertyValue,
} from "web_myplann/Portfolio/Components/Redesign/ListItem/propertyHelpers";
import type { CategoryItem } from "web_myplann/Portfolio/Types/portfolioCategory";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

type Props = {
	item: CategoryItem;
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const PortfolioListItemRedesign: FC<Props> = ({ item, summaryData }) => {
	const navigate = useNavigate();

	if (item.kind === PortfolioItemKind.Property) {
		const property = item.data;
		return (
			<PortfolioRow
				icon={<PortfolioItemIcon propertyType={property.property} />}
				title={<PropertyTitle data={property} />}
				badge={property.forInvestments ? <InvestmentPropertyBadge /> : null}
				subtitle={propertySubtitle(property)}
				right={<CurrencyAmount value={propertyValue(property)} />}
				onClick={() =>
					navigate(
						Routing.Portfolio.PropertyDetail.path(property.id.toString()),
					)
				}
			/>
		);
	}

	const portfolio = item.data;
	return (
		<PortfolioRow
			icon={
				<PortfolioItemIcon domain={portfolio.domain} logo={portfolio.icon} />
			}
			title={<PortfolioTitle data={portfolio} />}
			subtitle={portfolio.producer ?? ""}
			right={
				<PortfolioRowTrailing data={portfolio} summaryData={summaryData} />
			}
			onClick={() =>
				navigate(
					Routing.Portfolio.PortfolioDetail.path(portfolio.id.toString()),
				)
			}
		/>
	);
};
